import moment from 'moment';

/**
 * Format date strings
 * @param {String} isoDate
 */
export function formatDate(isoDate) {
  return moment(isoDate).format('ll');
}

export function formatDateWithZeros(isoDate) {
  return moment(isoDate).format('MMM DD, YYYY');
}

export function formatDateFullMonth(isoDate) {
  return moment(isoDate).format('MMMM DD, YYYY');
}

export function formatDateWithTime(isoDate) {
  return moment(isoDate).format('LLL');
}

/**
 * Format date strings
 * @param {String} isoDateStart
 * @param {String} isoDateEnd
 */
export function daysBetweenDates(isoDateStart, isoDateEnd) {
  const end = moment(isoDateEnd);
  const start = moment(isoDateStart);
  return Math.ceil(end.diff(start, 'days', true));
}

/**
 * @param  {Number} days
 * @return {Date}
 */
export function daysFromToday(days) {
  const today = new Date();
  today.setDate(today.getDate() + days);
  today.setHours(0, 1, 0, 0);
  return today;
}

/**
 * Set inputted date time to be 11:59PM
 * @param  {Date} date
 * @return {Date}
 */
export function endOfDay(date) {
  const newDate = new Date(date);
  newDate.setHours(23, 59, 0, 0);
  return newDate;
}



// WEBPACK FOOTER //
// ./src/utils/dateHelper.js